
import React from 'react';
import DashboardLayout from '../../../components/Shop/RestaurantLayout/Layout/DashboardLayout';
import OrderDetailsContainer from './OrderDetailsContainer';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.orderDetails);

    let isRestaurantAuthenticated = store.getState().runtime.isRestaurantAuthenticated;

    if (!isRestaurantAuthenticated) {
        return { redirect: '/restaurant' };
    };

    const type = params.type;
    const bookingId = params.id;

    return {
        title,
        component: <DashboardLayout>
            <OrderDetailsContainer title={title} type={type} bookingId={bookingId} />
        </DashboardLayout>
    };
}

export default action;
